module.exports = __webpack_public_path__ + "static/media/gradiant-background.9349d62a.png";